import _extends from "@babel/runtime/helpers/extends";
/**
 * This file generated by Stencil generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

import React from 'react';
import { withIconProps } from '../utils/withIconProps';
import { jsx as ___EmotionJSX } from "@emotion/react";
const IconArrowLeftLarge = withIconProps(props => {
  return ___EmotionJSX("svg", _extends({
    width: "32px",
    height: "32px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), ___EmotionJSX("path", {
    d: "M11.5607 9.06066C12.1464 8.47487 12.1464 7.52513 11.5607 6.93934C10.9749 6.35355 10.0251 6.35355 9.43934 6.93934L1.43934 14.9393C0.853553 15.5251 0.853553 16.4749 1.43934 17.0607L9.43934 25.0607C10.0251 25.6464 10.9749 25.6464 11.5607 25.0607C12.1464 24.4749 12.1464 23.5251 11.5607 22.9393L6.12132 17.5H29.5C30.3284 17.5 31 16.8284 31 16C31 15.1716 30.3284 14.5 29.5 14.5H6.12132L11.5607 9.06066Z",
    fill: "currentColor"
  }));
}, 'IconArrowLeftLarge');
IconArrowLeftLarge.displayName = 'IconArrowLeftLarge';
export default IconArrowLeftLarge;